import request from '@/utils/http';

// 司机运费管理白名单分页查询接口
export const queryPage = data => {
    return request({
        url: `/api-antms/common/baseDriverCostConfig/queryPage`,
        method: 'post',
        data
    });
};

// 新增
export const addDriverCostConfig = data => {
    return request({
        url: `/api-antms/common/baseDriverCostConfig/add`,
        method: 'post',
        data
    });
};

// 批量删除
export const batchDelete = data => {
    return request({
        url: `/api-antms/common/baseDriverCostConfig/delete`,
        method: 'post',
        data
    });
};

// 发起审批接口
export const createDriverCostConfig = data => {
    return request({
        url: `/api-antms/common/baseDriverCostConfig/iflow/create`,
        method: 'post',
        data
    });
};

// 审批流程信息查询接口
export const queryDriverCostConfig = data => {
    return request({
        url: `/api-antms/common/baseDriverCostConfig/iflow/query`,
        method: 'post',
        data
    });
};

// 审批流程信息查询接口
export const getIflowOrder = (params) => {
    return request({
        url: `/api-antms/common/iflowOrder/query/requestId?requestId=${params}`,
        method: 'get'
    });
};

// 附件查询
export const getFileList = data => {
    return request({
        url: `/api-antms/transport/attachment/page`,
        method: 'post',
        data
    });
};

// 删除图片
export const fileDelete = (params) => {
    return request({
        url: `api-antms/transport/attachment/delete?id=${params}`,
        method: 'get'
    });
};

// 图片上传接口
export const fileSave = params => {
    return request({
        url: `api-antms/transport/attachment/add`,
        method: 'post',
        data: params
    });
};

// 提交mip审核
export const createProcess = params => {
    return request({
        url: `/api-iflow/approveProcess?tenantCode=annto&appCode=APP202103050019`,
        method: 'post',
        data: params
    }).then(res => res);
};

export const getProcessStatus = params => {
    return request({
        url: `/api-iflow/public/getProcessStatus`,
        method: 'post',
        data: params
    });
};
